import * as React from 'react';

import { ChatSession } from '../App';
import { mergeRemoteAndLocalState } from '../helpers/state';
import { getPersistentState } from '../helpers/storage';

export interface UseRefreshChatSessionProps {
	state: Partial<ChatSession>;
	callback: (newSession: ChatSession) => void;
}

export const useRefreshChatSession = ({
	state,
	callback,
}: UseRefreshChatSessionProps) => {
	return async function refresh(): Promise<void> {
		const newChatSession = await mergeRemoteAndLocalState({
			...state,
			...getPersistentState(),
		});
		callback(newChatSession);
	};
};

export default useRefreshChatSession;
